import React from 'react';

const createComponent = (component: string, key: number) => React.createElement(component, { key: key });

export const AdditionalComponents: React.FC<{ components: string[] }> = ({ components }) => {
  if (components.length === 0) {
    return null;
  }
  return <div>{components.map((component, key) => component && createComponent(component, key))}</div>;
};
